import { ctaLoadingClass } from "./utils";

export const manageContactForm = () => {
  const form = document.querySelector<HTMLFormElement>("#ContactForm");

  if (!form) {
    return;
  }

  form.addEventListener("submit", (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const formData = new FormData(form);
    const country =
      document.querySelector<HTMLSelectElement>("#locale_code")!.value;
    const email = formData.get("contact[email]");
    const firstName = formData.get("contact[first_name]");
    const lastName = formData.get("contact[last_name]");
    const phoneNumber = formData.get("contact[phone_number]");
    const subject = formData.get("contact[subject]");
    const message = formData.get("contact[message]");

    const submitButton = form.querySelector<HTMLButtonElement>("[type=submit]");

    if (!submitButton) {
      return;
    }

    submitButton.disabled = true;
    submitButton.classList.add(ctaLoadingClass);

    window.dataLayer = window.dataLayer || [];

    fetch("/apps/catifa-api/app/api", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        command: "create_shop_contact",
        payload: {
          email,
          phone_number: phoneNumber,
          country,
          first_name: firstName,
          last_name: lastName,
          terms_and_conditions_acceptance: true,
          subject,
          message,
        },
      }),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((errorData) => {
            const errorMessage =
              errorData.message ||
              response.statusText ||
              "Failed to submit contact form";
            if (window.dataLayer !== undefined) {
              window.dataLayer.push({
                event: "form_error",
                type: "contact_us",
                message: errorMessage,
              });
            }
            throw new Error(errorMessage);
          });
        }
        return response;
      })
      .then(() => {
        if (window.dataLayer !== undefined) {
          window.dataLayer.push({
            event: "form_submit",
            type: "contact_us",
            email: email ?? "",
            phone: phoneNumber ?? "",
            marketing_consent: "true", // requested by the tracking company to pass it as a string
          });
        }

        form.reset();
        form.remove();
        document
          .querySelector(".catifa-form-success-message")
          ?.classList.remove("hidden");
      })
      .catch(() => {
        // TODO: handle error
      })
      .finally(() => {
        submitButton.disabled = false;
        submitButton.classList.remove(ctaLoadingClass);
      });
  });
};
